import React, { PropsWithChildren, ReactElement } from 'react';
import { TGlobalColors } from '@pb/styles';
import {
    TValidationNotificationProperties,
    TValidationNotificationStates,
} from './validation-notification.types';
import {
    StyledValidationNotification,
    StyledParagraph,
    StyledIcon,
    StyledWrapper,
} from './validation-notification.styled';

function mapStateToIconColor(
    state: TValidationNotificationStates
): TGlobalColors {
    switch (state) {
        case 'success':
            return 'green';
        case 'error':
        default:
            return 'red';
    }
}

export function ValidationNotification({
    state = 'error',
    children,
    className,
    marginBottom,
    color,
}: PropsWithChildren<TValidationNotificationProperties>): ReactElement {
    const globalColor = color ?? mapStateToIconColor(state);
    return (
        <StyledValidationNotification className={className}>
            <StyledWrapper>
                <StyledIcon
                    type={state === 'success' ? 'tickWithCircle' : 'alert'}
                    color={globalColor}
                    size={24}
                />
                <StyledParagraph
                    marginBottom={marginBottom}
                    color={globalColor}
                >
                    {children}
                </StyledParagraph>
            </StyledWrapper>
        </StyledValidationNotification>
    );
}
